"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuantityButton = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importStar(require("react"));

var context_1 = require("../context");

var button_1 = require("../styled/button");

var QuantityButton = function QuantityButton(_a) {
  var className = _a.className,
      __UIScope = _a.__UIScope,
      onClick = _a.onClick,
      testID = _a["data-testid"],
      isIncrement = _a.isIncrement,
      isDecrement = _a.isDecrement,
      label = _a.label;
  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'QuantityField__Button',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  var isInverse = (0, react_1.useContext)(context_1.QuantityFieldContext).isInverse;
  var buttonLabel = label !== null && label !== void 0 ? label : isIncrement ? 'increment' : 'decrement';
  return react_1.default.createElement(button_1.Button, {
    className: rootClasses,
    "data-testid": testID,
    onClick: onClick,
    isInverse: isInverse,
    "aria-label": buttonLabel,
    type: "button"
  }, isIncrement && react_1.default.createElement(ui_icon_1.Icon, {
    name: "plus",
    "aria-hidden": "true"
  }), isDecrement && react_1.default.createElement(ui_icon_1.Icon, {
    name: "minus",
    "aria-hidden": "true"
  }));
};

var QuantityButtonWithSpace = (0, ui_helper_with_space_1.withSpace)(QuantityButton);
exports.QuantityButton = QuantityButtonWithSpace;